import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  StartStockCountRootParamList,
  StockCountsRootParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
  useWithAppState,
} from "@towersystems/roam-common-native";
import { StartStockCountScreen } from "../StartStockCountScreen";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { StartStockCountForm } from "../../components/StartStockCountForm";
import { Drawer } from "react-native-ui-lib";
import { SelectLocationModalScreen } from "../../../../components/SelectLocationModalScreen";

export type StartStockCountRootScreenProps = NativeStackScreenProps<
  StockCountsRootParamList,
  "StartStockCountRootScreen"
> & {};

export const StartStockCountRootScreen = () => {
  const {
    appState: { locationId: activeLocationId },
  } = useWithAppState();

  const RootNavigator =
    createStackHeaderNavigator<StartStockCountRootParamList>();

  return (
    <StartStockCountForm.Provider
      defaultFormValues={{
        locationId: activeLocationId,
      }}
    >
      <RootNavigator.Navigator>
        <RootNavigator.Group
          screenOptions={{
            animationEnabled: true,
            headerTitleAlign: "center",
            title: "",
            headerLeft: () => <ModalCloseButton type="Cancel" />,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <RootNavigator.Screen
            name="StartStockCountScreen"
            component={StartStockCountScreen}
          />
        </RootNavigator.Group>
        <RootNavigator.Group
          screenOptions={{
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <RootNavigator.Screen
            name="SelectLocationModalScreen"
            component={SelectLocationModalScreen}
          />
        </RootNavigator.Group>
      </RootNavigator.Navigator>
    </StartStockCountForm.Provider>
  );
};
